

export function findActiveContactIndex(contacts : any, targetContactID : number) : number {
    const ln = contacts.length;
    if ( targetContactID === undefined ) return -1;
    for (let i = 0; i<ln; i++) {
        if ( contacts[i]?.original?.id === targetContactID ) { return i; }
    }

    return -1;
}

